import { useState, useEffect } from 'react';
import { supabase } from '@/lib/supabase';

export function useNotifications() {
    const [unreadCount, setUnreadCount] = useState(0);
    const [loading, setLoading] = useState(true);

    const fetchUnreadCount = async () => {
        const { data: { user } } = await supabase.auth.getUser();
        if (!user) {
            setUnreadCount(0);
            setLoading(false);
            return;
        }

        // Get the last seen timestamp
        const lastSeen = localStorage.getItem(`last_seen_updates_${user.id}`) || new Date(0).toISOString();

        // Count new public updates for user's reports
        const { data: reports } = await supabase
            .from('reports')
            .select('id')
            .eq('user_id', user.id);

        if (!reports || reports.length === 0) {
            setUnreadCount(0);
            setLoading(false);
            return;
        }

        const reportIds = reports.map(r => r.id);

        const { count, error } = await supabase
            .from('report_updates')
            .select('*', { count: 'exact', head: true })
            .in('report_id', reportIds)
            .eq('is_internal', false)
            .gt('created_at', lastSeen);

        if (!error && count !== null) {
            setUnreadCount(count);
        }
        setLoading(false);
    };

    const markAsRead = async () => {
        const { data: { user } } = await supabase.auth.getUser();
        if (user) {
            localStorage.setItem(`last_seen_updates_${user.id}`, new Date().toISOString());
            setUnreadCount(0);
        }
    };

    useEffect(() => {
        fetchUnreadCount();

        // Subscribe to new public updates
        const channel = supabase
            .channel('public_updates')
            .on(
                'postgres_changes',
                { event: 'INSERT', schema: 'public', table: 'report_updates', filter: 'is_internal=eq.false' },
                () => {
                    fetchUnreadCount();
                }
            )
            .subscribe();

        return () => {
            supabase.removeChannel(channel);
        };
    }, []);

    return { unreadCount, markAsRead, loading, refresh: fetchUnreadCount };
}
